import React from "react";

const NavTop2Component = () => {
  return (
    <div>
      <a href="#services" className="nav-top-2">
        <p>Delhi NCR doorstep appointments open</p> 
        <div>
        {/* <span>Delhi NCR doorstep appointments open</span> */}
        <div>(*Limited same-day slots)</div>
        </div>
      </a>
    </div>
  );
};

export default NavTop2Component;
